// extracted by mini-css-extract-plugin
export var active = "W6ewvHlbGPeitT6dUE_a";
export var customTitle2 = "ujQnO27Zqw0YSTnf8pXe";
export var destructive = "s5zmvvuaJ1s85p3MtZII";
export var focusVisible = "FE95O_8S47Zqf3gFuGCA";
export var fullWidth = "rVZZuuoTKFFPn5u9nJz_";
export var ghost = "iFndcUibYRVPbpkaYWH0";
export var icon = "qAkkruAuAD384Njs8e0F";
export var iconPlaceholder = "NK4_8Z5CYC6sBKEbIUnx";
export var large = "eNxjMngiZ4VRhCoYp5vJ";
export var loading = "uExn1BjUeX646suYhvaG";
export var medium = "RzfMH6fPtKiaLfHAsrgg";
export var primary = "c1B7jTsHVss7j31P0jJK";
export var root = "asrdFhYkC0lpexxVGFYb";
export var secondary1 = "fwU7zoKxini4AIxqG8CL";
export var secondary2 = "iUyVIpgRI8WVsMLcZyBf";
export var secondary3 = "JqC6YMoFMEorCgPSfxze";
export var small = "bFFHtXeKBRbQh02kRJpq";
export var spinner = "Fr7_BJv68zgkkOpVLDp3";
export var tertiary = "vHu6PJk8kLIZ276EYwrS";
export var tertiaryDestructive = "lySW9HWqoGp5ZhldXaVg";
export var text = "igwQc_dnHxfqZiUbo2aC";
export var xLarge = "NOOs8B0IBKT0NGS914VV";